import { createTheme } from '@mui/material/styles';

const BRAND_GREEN = '#07845a';
const BRAND_GREEN_DARK = '#056b48';
const TEXT_PRIMARY = '#111827';
const TEXT_SECONDARY = '#4b5563';
const BORDER = '#d1d5db';

const cofounderTheme = createTheme({
  spacing: 7,
  shape: {
    borderRadius: 8,
  },
  palette: {
    mode: 'light',
    primary: {
      main: BRAND_GREEN,
      dark: BRAND_GREEN_DARK,
      light: '#0ea371',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#374151',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    text: {
      primary: TEXT_PRIMARY,
      secondary: TEXT_SECONDARY,
    },
    divider: '#e5e7eb',
    error: {
      main: '#b91c1c',
    },
    success: {
      main: BRAND_GREEN,
    },
  },
  typography: {
    fontFamily: '"Source Sans 3", "Segoe UI", Helvetica, Arial, sans-serif',
    h1: {
      fontFamily: '"Fraunces", Georgia, "Times New Roman", serif',
      fontWeight: 650,
      letterSpacing: '-0.02em',
      color: TEXT_PRIMARY,
    },
    h2: {
      fontFamily: '"Fraunces", Georgia, "Times New Roman", serif',
      fontWeight: 650,
      letterSpacing: '-0.02em',
      color: TEXT_PRIMARY,
    },
    h3: {
      fontFamily: '"Fraunces", Georgia, "Times New Roman", serif',
      fontWeight: 600,
      color: TEXT_PRIMARY,
    },
    h4: {
      fontFamily: '"Fraunces", Georgia, "Times New Roman", serif',
      fontWeight: 600,
      color: TEXT_PRIMARY,
    },
    h5: {
      fontFamily: '"Source Sans 3", sans-serif',
      fontWeight: 650,
      color: TEXT_PRIMARY,
    },
    h6: {
      fontFamily: '"Source Sans 3", sans-serif',
      fontWeight: 650,
      color: TEXT_PRIMARY,
    },
    body1: {
      fontSize: '0.975rem',
      lineHeight: 1.55,
      color: TEXT_SECONDARY,
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
      color: TEXT_SECONDARY,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
      letterSpacing: 0,
    },
  },
  transitions: {
    duration: {
      shortest: 120,
      shorter: 160,
      short: 200,
      standard: 220,
      complex: 280,
      enteringScreen: 200,
      leavingScreen: 160,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: '#ffffff',
          color: TEXT_PRIMARY,
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 8,
          minHeight: 40,
          paddingInline: 16,
          transition: 'background-color 180ms ease, transform 180ms ease, box-shadow 180ms ease',
          '&:hover': {
            transform: 'translateY(-1px)',
          },
          '@media (prefers-reduced-motion: reduce)': {
            transition: 'none',
            '&:hover': {
              transform: 'none',
            },
          },
        },
        containedPrimary: {
          backgroundColor: BRAND_GREEN,
          '&:hover': {
            backgroundColor: BRAND_GREEN_DARK,
          },
        },
        outlined: {
          borderColor: BORDER,
        },
        sizeSmall: {
          minHeight: 34,
          paddingInline: 12,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
        variant: 'outlined',
        fullWidth: true,
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: BRAND_GREEN,
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: BRAND_GREEN,
            borderWidth: 1.5,
          },
        },
        input: {
          paddingTop: 9,
          paddingBottom: 9,
        },
        notchedOutline: {
          borderColor: BORDER,
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '0.875rem',
          '&.Mui-focused': {
            color: BRAND_GREEN,
          },
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: `1px solid #e5e7eb`,
        },
        rounded: {
          borderRadius: 12,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          height: 4,
          borderRadius: 999,
          backgroundColor: '#e5e7eb',
        },
        bar: {
          borderRadius: 999,
          backgroundColor: BRAND_GREEN,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

export default cofounderTheme;
